module.exports = __webpack_public_path__ + "img/组 7476.15709652.png";